import React from 'react';
import { Provider } from 'react-redux';
import './i18n';
import { loadRuntimeOperations } from './helpers/operationsHelper';
import store from './store';
import GlobalStyle from './styles/global';
import { Normalize } from 'styled-normalize';
import '@ikea-customer-self-serve/contact-form/dist/contact-form.css';

// Importing global styles
import '@ingka/button/dist/style.css';
import '@ingka/choice/dist/style.css';
import '@ingka/focus/dist/style.css';
import '@ingka/forms/dist/style.css';
import '@ingka/hyperlink/dist/style.css';
import '@ingka/inline-message/dist/style.css';
import '@ingka/jumbo-button/dist/style.css';
import '@ingka/loading/dist/style.css';
import '@ingka/list/dist/style.css';
import '@ingka/modal/dist/style.css';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/switch/dist/style.css';
import '@ingka/typography/dist/style.css';
import '@ingka/text/dist/style.css';
import '@ingka/price/dist/style.css';
import '@ingka/commercial-message/dist/style.css';
import '@ingka/price-module/dist/style.css';
import '@ingka/helper-text/dist/style.css';
import '@ingka/progress-indicator/dist/style.css';
import './styles/_ikea-theme-dark.css';
import { styled } from 'styled-components';
import type { AppView } from './types/app';
import { ViewContext } from './context';
import colors from './styles/colors';

loadRuntimeOperations();

/**
 * App-level wrapper at the root of the component tree. Provides global context
 * (state management, i18n, design system styles) that persists across page
 * navigation without unmounting.
 */

const Main = styled.main`
  max-width: 906px;
  margin: 0 auto;
  font-family:
    Noto IKEA,
    Noto Sans,
    Roboto,
    Open Sans,
    sans-serif;
  color: ${colors.text.default};
  background: ${colors.background.default};
`;

const TimeSlotsTodayMain = styled.main`
  font-family:
    Noto IKEA,
    Noto Sans,
    Roboto,
    Open Sans,
    sans-serif;
  color: ${colors.text.default};
  background: ${colors.background.default};
`;

const RootWrapper: React.FC<{ view: AppView; children: React.ReactNode }> = ({
  view,
  children,
}) => {
  const MainComponent = view === 'timeslotstoday' ? TimeSlotsTodayMain : Main;
  return (
    <>
      <GlobalStyle />
      <Normalize />
      <MainComponent>
        <Provider store={store}>
          <ViewContext value={view}>{children}</ViewContext>
        </Provider>
      </MainComponent>
    </>
  );
};

export default RootWrapper;
